export const SIZE = {
  DEFAULT: 24,
} as const;
